import { client } from "../generated/client.gen";
import { getAccessToken } from "./auth";

client.interceptors.request.use(async (options) => {
  // Ignore adding auth header for new token request
  if (options.url.endsWith("/auth/token")) return;

  const token = await getAccessToken();

  (options.headers as Headers).set("Authorization", `Bearer ${token}`);
});

export * from "../generated/index";
export * from "../generated/client.gen";
export * from "./auth";
export * from "./constants";
export {
  serializeKinsaDataToText,
  type KinsaData,
  type KinsaEpisodeCustomData,
} from "./utils/serialize-kinsa-data";
